export default {
  title: 'Testiyleisö',
  columns: {
    id: 'Tunnus',
    phone_number: 'Puhelinnumero',
  },
  filters: {
    search: {
      placeholder: 'Haku',
    },
  },
  buttons: {
    send_test: 'Lähetä testi',
  },
  feedback: {
    success: 'Lähetetty onnistuneesti',
    error: 'Lähetys epäonnistui',
  },
};
